import { render, staticRenderFns } from "./MallaList.vue?vue&type=template&id=beb7200a&scoped=true&"
import script from "./MallaList.vue?vue&type=script&lang=js&"
export * from "./MallaList.vue?vue&type=script&lang=js&"
import style0 from "./MallaList.vue?vue&type=style&index=0&id=beb7200a&prod&lang=scss&scoped=true&"
import style1 from "./MallaList.vue?vue&type=style&index=1&id=beb7200a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb7200a",
  null
  
)

export default component.exports